// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"263eb152","1748":"06c5896f","1759":"367546fc","1910":"367546fc","2655":"20d3c4e6","3546":"510332b1","5086":"367546fc","5597":"367546fc"}[chunkId] + ".chunk.css";
};